// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"55cff943","977":"36966d83"}[chunkId] + ".chunk.js";
};